export default [
  {
    header: "Evaluaciones",
    title: "EDD",
    icon: "FileTextIcon",
    route: "verifiers-performances-list",
    action: "read",
    resource: "performances",
  },
];
